// src/components/Annotation/VehicleSegmentMode.ts
import { ObbAnnotation } from "../../api/Application";
import { DrawingStateFns, Mode, ModeParking, ModeVehicleParts } from "./ModeContext";
import { parseVehicleType } from "./VehicleType";
import { FeatureCol, isSupported, isValid } from "./VehiclePartsModeUtil";
import { GeoJsonLayer } from "deck.gl";
import { Pixel } from "../../common/Geography";
import { Feature, Geometry } from "geojson";

let partLayerCache: { key: string; layer: FeatureCol } | null = null;

export function createParkingMode(): ModeParking {
    return { mode: Mode.Parking, line: undefined, extent: undefined };
}

export const parkingMode: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        const mode = drawMode as ModeVehicleParts;
        return [
            null, null, null, null, null,
            null, null, null, null, null,
            null, null, null, null, null
        ];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        const mode = drawMode as ModeVehicleParts;
        return false;
    },

    onDeckClick( drawMode, info, ctx ) {
        const mode = drawMode as ModeParking;
        if( mode.line === undefined ) {
            ctx.setDrawMode( { ...mode, line: [info.coordinate as Pixel] } );
            return;
        }        
        if( mode.line.length === 1 ) {
            ctx.setDrawMode( { ...mode, line: [...mode.line, info.coordinate as Pixel] } );
            return;
        }
        if( mode.line.length === 2 ) {
            ctx.setDrawMode( { ...mode, extent: info.coordinate as Pixel } );
            return;
        }
    },

    onDeckHover( drawMode, info, ctx ) {
        //nothing to do...
    },

    onAnnotationClick( drawMode, ann, ctx ) {
        //don't do anything        
    },

    filter( drawMode, ann ) {
        //only show annotations that have a vehicle type this mode can handle
        return isSupported( ann );
    },

    getLineColor( drawMode, ann, ctx ) {
        type Color4   = [number, number, number, number];
        const hidden  = [0, 0, 0, 0] as Color4;
        return hidden;
    },

    getCursor( drawMode ) {
        const mode = drawMode as ModeVehicleParts;        
        return "crosshair";
    },

    getAnnotationLabel( drawMode, ann ) {
        return "";
    },

    /**
     * Produce a GeoJsonLayer showing the current annotation's body segments as
     * colored rectangles along the vehicle length axis. Called every render.
     * Internally memoized: only rebuilds the layer when its actual inputs change.
     */
    getLayer( drawMode, allAnnotations, ctx ) {
        const mode = drawMode as ModeParking;
        interface FeatureProperties { kind: "line"; }
        interface FeatureCol {
            type:     "FeatureCollection";
            features: Feature<Geometry, FeatureProperties>[];
        }
        function createParkFeature( line: Pixel[] ): Feature<Geometry, FeatureProperties> {
            return {
                type: "Feature",
                geometry: { type: "LineString", coordinates: line },
                properties: { kind: "line" }
            };
        }
        
        function buildGeoJsonLayer( data: FeatureCol ) {
            return new GeoJsonLayer<FeatureProperties>( {
                id:                 "spaces",
                data:               data,
                stroked:            true,
                filled:             true,
                getLineWidth:       0.25,
                lineWidthMinPixels: 2.00,
                getFillColor: f => {
                    return [0, 0, 0, 0];
                },
                getLineColor: f => {
                    return [255, 255, 255, 255];
                },
                pickable: false
            } );
        }
        if( mode.line === undefined ) {
            return null;
        }
        if( mode.line.length === 2 ) {
            const features = createParkFeature( mode.line );
            const res: FeatureCol = { type: "FeatureCollection", features: [features] };
            console.log( "rendering" );
            return buildGeoJsonLayer( res );            
        }
        return null;        
    }
};
